import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import Hud from 'app/ui/Hud';
import { createTextField } from 'utils/Text';
import { FONT_TITLE, FONT_COLOUR_LEVEL_WIN, FONT_COLOUR_STROKE } from 'app/constants/AppConstants';
import { GAME_SFX_MUSICAL_MOMENT, GAME_SFX_APPLE_WIN, GAME_SFX_ONION_WIN } from 'app/constants/GameSFX';
import { FONT_COLOUR_BLACK } from '../constants/AppConstants';

class LevelEnd extends Phaser.State {
  init({ character }) {
    this.character = character;
  }

  preload(game) {}

  create(game) {
    this.game = game;

    this.background = game.make.image(0, 0, 'bg_level_complete');
    this.background.anchor.set(0, 1);
    this.game.add.existing(this.background);

    this.container = game.add.group();

    this.game.hud.activate({ id: Hud.LEVELEND });
    this.game.hud.fadeIn();

    this.game.sounds.playSFX(GAME_SFX_MUSICAL_MOMENT);
    if (this.character == 'apple') {
      this.game.sounds.playSFX(GAME_SFX_APPLE_WIN);
    } else {
      this.game.sounds.playSFX(GAME_SFX_ONION_WIN);
    }

    this.createCharacters();

    this.createText();

    // play again button
    this.btnPlay = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play' });
    this.btnPlay.x = this.game.defaultWidth * 0.5;
    this.btnPlay.y = this.game.defaultHeight * 0.75;
    this.btnPlay.onInputDown.add(this.handlePlayGame, this);
    this.container.add(this.btnPlay);

    this.logo = this.game.make.image(0, 0, 'logo_game');
    this.logo.anchor.set(1);
    this.logo.scale.set(0.33);
    this.logo.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 30, this.game.defaultHeight - 60);
    this.container.addChild(this.logo);

    this.game.sounds.playGameMusic();

    this.game.windowEventController.handleWindowResize();
    this.game.scale.onSizeChange.add(this.positionContainer, this);
    this.positionContainer();
  }

  createCharacters() {
    switch (this.character) {
      case 'apple':
        this.winCostume = this.game.make.sprite(0, 0, 'apple_endings', 'apple_complete_0001');
        this.winCostume.animations.add('win', Phaser.Animation.generateFrameNames('apple_complete_', 0, 29, '', 4), 24, true);
        this.winCostume.anchor.set(0.5, 1);
        this.winCostume.position.set(this.game.defaultWidth * 0.3, this.game.defaultHeight * 0.9);
        break;
      case 'onion':
        this.winCostume = this.game.make.sprite(0, 0, 'onion_endings', 'onion_complete_0001');
        this.winCostume.animations.add('win', Phaser.Animation.generateFrameNames('onion_complete_', 0, 30, '', 4), 24, true);
        this.winCostume.anchor.set(0.5, 1);
        this.winCostume.position.set(this.game.defaultWidth * 0.3, this.game.defaultHeight * 0.9);
        break;
    }

    this.winCostume.play('win');

    this.game.add.existing(this.winCostume);
  }

  createText() {
    this.mainCopy = createTextField(this.game, FONT_TITLE, 78, FONT_COLOUR_LEVEL_WIN, 0, 0, {
      align: 'center',
      stroke: FONT_COLOUR_STROKE,
      strokeThickness: 6,
    });
    this.mainCopy.text =
      this.game.copy.getCopy('level') + ' ' + this.game.controller.gameModel.getCurrentLevel() + ' ' + this.game.copy.getCopy('complete');
    this.mainCopy.anchor.set(0.5);
    this.mainCopy.angle = -5;
    this.mainCopy.setShadow(3, 3, 'rgba(0,0,0,0.5)', 0);

    this.mainCopy.scale.set(100);

    this.game.add.existing(this.mainCopy);
    this.tweenText();
  }

  tweenText() {
    this.scaleTweenDown = this.game.add.tween(this.mainCopy.scale).to({ x: 0.7, y: 0.7 }, 500, Phaser.Easing.Quartic.Out, true);
    this.scaleTweenUp = this.game.add.tween(this.mainCopy.scale).to({ x: 1, y: 1 }, 150, Phaser.Easing.Quartic.Out, false);

    this.scaleTweenDown.chain(this.scaleTweenUp);
    this.scaleTweenDown.onComplete.add(this.playStampSound, this);
  }

  playStampSound() {
    this.game.sounds.playSFX('stamp');
  }

  positionContainer() {
    const x = (this.game.width - this.game.defaultWidth) * 0.5;
    const y = (this.game.height - this.game.defaultHeight) * 0.5;
    this.container.position.set(x, y);

    this.logo.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 30, this.game.defaultHeight - 60);

    let scale = Math.max(this.game.height / this.game.defaultHeight, this.game.width / this.game.defaultWidth);
    this.background.scale.set(scale);
    this.background.position.set(0, this.game.height);

    let yOffset = 1 - scale;
    yOffset /= 4;
    this.winCostume.position.set(this.game.width * 0.3, this.game.height * (0.9 + yOffset));

    this.mainCopy.position.set(this.game.width * 0.5, this.game.height * 0.21);
  }

  handlePlayGame() {
    this.game.controller.gameModel.levelUp();
    this.game.controller.startLevel(this.game.controller.gameModel.getCurrentLevel());
  }

  shutdown(game) {
    game.scale.onSizeChange.remove(this.positionContainer, this);
    this.btnPlay.onInputDown.remove(this.handlePlayGame, this);
    this.scaleTweenDown.onComplete.remove(this.playStampSound, this);
    // destroy
    this.background.destroy(true);
    this.container.destroy(true);

    this.winCostume.destroy(true);
    this.mainCopy.destroy(true);
    this.btnPlay.destroy(true);

    // clear up
    this.background = null;
    this.container = null;
    this.posterMain = null;
    this.posterSmall = null;
    this.winCostume = null;
    this.mainCopy = null;
    this.smallCopy = null;
    this.btnPlay = null;
  }
}

export default LevelEnd;
